// Equirectangular projection tuned to the continental US.
// Converts geographic (lng, lat) to 3D world (x, z) on the map plane.
const CENTER = { lat: 38.5, lng: -96.0 };
const SCALE = 0.42;
const COS0 = Math.cos((CENTER.lat * Math.PI) / 180);

export function project(lng, lat) {
  const x = (lng - CENTER.lng) * COS0 * SCALE;
  const z = -(lat - CENTER.lat) * SCALE;
  return [x, z];
}

// States excluded from the continental wireframe (kept off-map for clarity).
export const EXCLUDED_STATES = new Set(["Alaska", "Hawaii", "Puerto Rico"]);
